import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft, Home } from 'lucide-react';
import { Button } from '../ui/button';

export const BackButton = ({ to, label }) => {
  const navigate = useNavigate();
  
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => to ? navigate(to) : navigate(-1)}
      className="mb-4"
    >
      <ChevronLeft className="w-4 h-4 mr-1" />
      {label || 'Back'}
    </Button>
  );
};

export const Breadcrumbs = ({ items }) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground mb-4">
      <button
        onClick={() => navigate('/app/home')}
        className="hover:text-foreground transition-colors"
      >
        <Home className="w-4 h-4" />
      </button>
      
      {items?.map((item, index) => (
        <React.Fragment key={index}>
          <span>/</span>
          {item.href ? (
            <button
              onClick={() => navigate(item.href)}
              className="hover:text-foreground transition-colors"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-foreground font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
